module.exports = __webpack_public_path__ + "img/020021.5764d531.png";